<script>
  // The user menu's language picker: a native <select>, since the language list is a fixed enum.
  import { i18n, LANGUAGES, setLang, t } from "./i18n.svelte.js";
</script>

<select
  aria-label={t("change_language")}
  value={i18n.lang}
  onchange={(event) => setLang(event.currentTarget.value)}
>
  {#each LANGUAGES as language (language.code)}
    <option value={language.code}>{language.label}</option>
  {/each}
</select>

<style>
  select {
    margin: 2px 10px 4px;
    min-width: 0;
  }
</style>
